module.exports = __webpack_public_path__ + "img/CheckMarkIcon.88168fab.svg";